import {
  addDigitalTwinEndpoint,
  deleteDigitalTwinEndpoint,
  updateDigitalTwinEndpoint,
} from "./api/DigitalTwin";

export const addDigitalTwin = async digitalTwinData => {
  try {
    const newDigitalTwin = digitalTwinData;
    const response = await addDigitalTwinEndpoint(newDigitalTwin);
    return response;
  } catch (error) {
    throw new Error(`Error adding new DigitalTwin: ${error.message}`);
  }
};

export const updateDigitalTwin = async (
  updatedDigitalTwinData,
  digitalTwinId
) => {
  try {
    const response = await updateDigitalTwinEndpoint(
      updatedDigitalTwinData,
      digitalTwinId
    );
    return response;
  } catch (error) {
    throw new Error(`Error updating DigitalTwin: ${error.message}`);
  }
};

export const deleteDigitalTwin = async digitalTwinId => {
  try {
    const response = await deleteDigitalTwinEndpoint(digitalTwinId);
    return response;
  } catch (error) {
    throw new Error(`Error deleting Digital Twin: ${error.message}`);
  }
};
